namespace Matrix.Scheduling {
    export interface CalendarGetEntriesRequest extends Serenity.ServiceRequest {
        CalendarCodes?: string[];
    }
}
